import React, { lazy, Suspense } from 'react';
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import withTracker from './GoogleTracker';
import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@iso/components/utility/loader';

const Dashboard = lazy(() => import('./screens/Dashboard/Dashboard'));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: withTracker(lazy(() => import('./screens/Auth/AuthComponent'))),
    props: {
      type: 'login',
    },
  },
  {
    path: PUBLIC_ROUTE.COMPANYINVITE,
    exact: true,
    component: withTracker(lazy(() => import('./screens/Auth/companyInvite'))),
    props: {
      type: 'register',
    },
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: withTracker(lazy(() => import('./screens/Auth/AuthComponent'))),
    props: {
      type: 'login',
    },
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    component: withTracker(lazy(() => import('./screens/Auth/AuthComponent'))),
    props: {
      type: 'register',
    },
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    component: withTracker(lazy(() => import('./screens/Auth/ForgotPassword'))),
  },
  {
    path: PUBLIC_ROUTE.VERIFY_EMAIL,
    component: lazy(() => import('./screens/Auth/EmailVerify')),
  },
  {
    path: PUBLIC_ROUTE.INVITE_ACCEPT,
    component: lazy(() => import('./screens/Auth/InviteAccept')),
  },
];
function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector((state) => state.Auth.idToken);
  if (isLoggedIn !== null) {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          Object.keys(isLoggedIn).length > 0 ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          )
        }
      />
    );
  }

  return <Loader />;
}
export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component {...route.props} />
              </Route>
            ))}
            <PrivateRoute path='/dashboard'>
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
